import mwrHttp from '@/utils/mwrHttp'
const isDev = process.env.VUE_APP_ENV === 'dev'
const basePath = isDev ? '/minifire-mwr-2025/api/v1' : '/minifire-mwr-2025/api/v1'
export default {
  // 获取用户统计数据-需要登录
  getStatsData: (params) => {
    return mwrHttp.post(`${basePath}/get-mwr-detail`, params)
  },
  // 登录
  login: (params) => {
    return mwrHttp.post(`${basePath}/login`, params)
  },
  // 登录
  loginNoLoading: (params) => {
    return mwrHttp.post(`${basePath}/login`, { ...params, _loading: 0 })
  },
  // 获取公共配置
  getCommonConfig: (params) => {
    return mwrHttp.post(`${basePath}/get-common-config`, params)
  },
  // 打龙 -需要登录
  shootDragon: (params) => {
    return mwrHttp.post(`${basePath}/shoot-dragon`, { ...params, _loading: 0 })
  },
  // 获取打龙信息-需要登录
  getShootDetail: (params) => {
    return mwrHttp.post(`${basePath}/get-shoot-detail`, params)
  },
  // 完成任务明细--需要登录
  getTaskDetail: (params) => {
    return mwrHttp.post(`${basePath}/get-task-detail`, params)
  },
  // 记录用户行为-如分享-需要登录
  recordUserAction: (params) => {
    return mwrHttp.post(`${basePath}/record-user-action`, params)
  },
  // 领取任务奖励-需要登录
  receiveTaskReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-task-reward`, params)
  },
  // 领取宝箱奖励-需要登录
  receiveBoxReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-box-reward`, params)
  },
  // 宝箱领取记录-需要登录
  getBoxRewardRecord: (params) => {
    return mwrHttp.post(`${basePath}/get-box-reward-record`, params)
  },
}

